export { default } from './TitleTextContentsLayout';
